/* Every Rise — global.js */
(function () {
  'use strict';

  window.EveryRise = window.EveryRise || {};

  /* ---------- Utilities ---------- */
  EveryRise.fetchConfig = function (type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  };

  EveryRise.debounce = function (fn, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  EveryRise.trapFocus = function (container) {
    const focusable = container.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    function handleKey(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    container.addEventListener('keydown', handleKey);
    first.focus();
  };

  /* ---------- Sticky / transparent header ---------- */
  const header = document.getElementById('SiteHeader');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  const mobileMenu = document.getElementById('MobileMenu');
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const menuClosers = document.querySelectorAll('[data-mobile-menu-close]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    document.body.style.overflow = 'hidden';
    menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    EveryRise.trapFocus(mobileMenu);
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.hidden = true;
    document.body.style.overflow = '';
    menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
  }
  menuToggle && menuToggle.addEventListener('click', openMobileMenu);
  menuClosers.forEach((el) => el.addEventListener('click', closeMobileMenu));

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const submenu = btn.nextElementSibling;
      if (!submenu) return;
      const isHidden = submenu.hidden;
      submenu.hidden = !isHidden;
      btn.classList.toggle('is-open', isHidden);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMobileMenu();
  });

  /* ---------- Quick add modal ---------- */
  const quickAddModal = document.getElementById('quick-add-modal');
  const quickAddContent = document.getElementById('QuickAddContent');

  function openQuickAdd(handle) {
    if (!quickAddModal || !quickAddContent) return;
    quickAddContent.innerHTML = '<p class="quick-add__loading">Loading…</p>';
    quickAddModal.hidden = false;
    document.body.style.overflow = 'hidden';
    fetch(`/products/${handle}?section_id=quick-add`)
      .then((res) => res.text())
      .then((html) => {
        quickAddContent.innerHTML = html;
        EveryRise.initProductForms(quickAddContent);
      })
      .catch(() => {
        quickAddContent.innerHTML = '<p>Unable to load product.</p>';
      });
  }
  function closeQuickAdd() {
    if (!quickAddModal) return;
    quickAddModal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-add-open]');
    if (trigger) {
      e.preventDefault();
      openQuickAdd(trigger.getAttribute('data-product-handle'));
    }
    if (e.target.closest('[data-quick-add-close]')) {
      closeQuickAdd();
    }
  });

  /* ---------- Accordion chevrons already handled via <details> ---------- */

  /* ---------- Size guide modal ---------- */
  const sizeGuideModal = document.getElementById('SizeGuideModal');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-size-guide-open]')) {
      if (sizeGuideModal) {
        sizeGuideModal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    }
    if (e.target.closest('[data-size-guide-close]')) {
      if (sizeGuideModal) {
        sizeGuideModal.hidden = true;
        document.body.style.overflow = '';
      }
    }
  });

  /* ---------- Generic quantity steppers (cart drawer / cart page / PDP) ---------- */
  document.addEventListener('click', (e) => {
    const decrease = e.target.closest('[data-qty-decrease]');
    const increase = e.target.closest('[data-qty-increase]');
    if (!decrease && !increase) return;
    const wrapper = (decrease || increase).closest('.quantity-selector, .cart-drawer__item-qty');
    if (!wrapper) return;
    const input = wrapper.querySelector('[data-qty-input]');
    if (!input) return;
    let value = parseInt(input.value, 10) || 1;
    value = decrease ? Math.max(0, value - 1) : value + 1;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
